// /js/api/api.js
import { store } from "../store/store.js";
import { alertas } from "../ui/alerts.js";
import { get_member_reference, empty_references_storage } from "../utils/members_reference.js";



/*USER*/
/*USER*/
/*USER*/
/*USER*/
/*USER*/

export async function register() {



  const refs = get_member_reference();

  console.log(refs.member);
  console.log(refs.guide);

  console.log(store.GLOBAL_NAME);
  console.log(store.GLOBAL_EMAIL);
  console.log(store.GLOBAL_PASSWROD);


  const form = new FormData();
  form.append("nombre", store.GLOBAL_NAME);
  form.append("email", store.GLOBAL_EMAIL);
  form.append("password", store.GLOBAL_PASSWORD);
  form.append("tipo_registro", 1);
  form.append("vendedor_id", refs.member);
  form.append("auto_login", "1");

  const res = await fetch(
    `${store.URL_PHP}Dashboard/create_user`,
    { method:"POST", body: form, credentials:"include" }
  );

  const json = await res.json();

  if (json.success !== 1) {
    alertas({ type:"error", title:"Error", message: json.message });
    return;
  }


  empty_references_storage();
  location.href = `${store.URL_PHP}Dashboard/index`;

  // después de crear usuario, registras pago
  //actualizar_pago_user(json.user_id);
}







export function actualizar_pago_user(user_id){



  const refs = get_member_reference();


  let txt_reference_member = refs.member;
  if (!txt_reference_member || txt_reference_member === "null") txt_reference_member = "null";


  let txt_reference_guide = refs.guide;
  if (!txt_reference_guide || txt_reference_guide === "null") txt_reference_guide = "null";


  const data_ = {
    user_id,
    total_pago: store.SELECTED_PRICE,
    external_reference_member: txt_reference_member,
    referencia_guia: txt_reference_guide
  };

  $.ajax({
    url: `${store.URL_PHP}Dashboard/nuevo_pago/`,
    type: "POST",
    dataType: "json",
    data: JSON.stringify(data_),
    success: function(response){
      if(response?.success == 1){

        empty_references_storage();
        location.href = `${store.URL_PHP}Dashboard/index`;

      } else {
        alertas({ type:"error", title:"Error", message:"Try Latter." });
      }
    }
  });
}







export async function loginUser(form, btn) {

//btn.preventDefault(); // evitamos reload

  // 🔒 deshabilitar botón
  btn.disabled = true;
  btn.classList.add("disabled");
  btn.innerText = "Logging in...";


  const res = await postForm(store.URL_PHP + 'Dashboard/login_func', form);

  console.log("LOGIN RESPONSE:", res);

  //alert(JSON.stringify(res))

  if (res.success === 1) {

     if (res.had_previous_session) {
        
          alertas({
              type: "warning",
              title: "Active Session Detected",
              message: "Your account was open on another device. We recommend changing your password.",
              buttonText: "Open here",
              redirect: store.URL_PHP + "Dashboard/index"
            }); 


     }else{
      location.href = store.URL_PHP + 'Dashboard/index';
     }
    
    return;
  }
  

  // errores controlados
  switch (res.code) {
    case 'USER_NOT_FOUND':

           alertas({
              type: "error",
              title: "User not found",
              message: "This email is not registered.",
              buttonText: "Close"
            });

      break;

    case 'WRONG_PASSWORD':
      
            alertas({
              type: "error",
              title: "Password Error",
              message: "",
              buttonText: "Close"
            });

      break;

    case 'USER_INACTIVE':
            alertas({
              type: "error",
              title: "Inactive User",
              message: "",
              buttonText: "Close"
            });
      break;

    default:
      alertas({
              type: "error",
              title: "Error",
              message: "Try Again Latter",
              buttonText: "Close"
            });
  }


  // 🔓 reactivar botón en error
    btn.disabled = false;
    btn.classList.remove("disabled");
    btn.innerText = "Login";


}




let FORGOT_ALREADY_SENT = false;

export async function forgotPassword(form, btn){

    // 🚫 evitar múltiples ejecuciones
  if (FORGOT_ALREADY_SENT) return;
  FORGOT_ALREADY_SENT = true;

   // 🔒 bloquear botón
  btn.disabled = true;


  const msg = document.getElementById("forgotMsg");
  msg.textContent = "Sending...";
  try{
    await postForm(store.URL_PHP+'Dashboard/forgot_password',form);
    msg.textContent = "If the email exists, you will receive instructions.";
  }catch{
    msg.textContent = "Server error.";
  }
}





/* ===================== HELPER ===================== */
/*
export async function postForm(url, form) {
  const res = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    body: form
  });

  const text = await res.text();
  try {
    return JSON.parse(text);
  } catch {
    console.error('Non-JSON response:', text);
    throw new Error('Invalid server response');
  }
}
*/


export async function postForm(url, form) {
  if (!(form instanceof HTMLFormElement)) {
    throw new Error("postForm expects an HTMLFormElement");
  }

  const formData = new FormData(form);

  const res = await fetch(url, {
    method: "POST",
    credentials: "include",
    body: formData
  });

  const text = await res.text();
  console.log("RAW SERVER RESPONSE:", text);

  try {
    return JSON.parse(text);
  } catch {
    throw new Error("Server did not return valid JSON");
  }
}





/*USER*/
/*USER*/
/*USER*/
/*USER*/
/*USER*/

